<template>
  <main-header class="justify-content-start">
    <logo class="ms-3" :with-top-link="false" />
    <span class="d-flex text-white ms-3">仲介業者向けシステム</span>
    <ul class="header-nav ms-auto me-3">
      <manual-browse-item />
    </ul>
  </main-header>
</template>

<script>
import MainHeader from '@/views/atoms/MainHeader'
import Logo from '@/views/atoms/Logo'
import ManualBrowseItem from '@/views/molecules/browseItems/ManualBrowseItem'

export default {
  name: "UnauthorizedHeader",
  props: {
    title: {
      type: String,
      default: ''
    },
  },
  components: {
    MainHeader,
    Logo,
    ManualBrowseItem,
  },
}
</script>
